import { type FC } from 'react';
import { useHistory } from 'react-router-dom';
import { DiscoverRentalCard as WrappedRentalCard } from '@rivallapp/volosports-components';

interface DiscoverRentalCardProps {
  id: string;
  viewType: 'sportView' | 'venueView';
}

const DiscoverRentalCard: FC<DiscoverRentalCardProps> = ({ id, viewType = 'sportView' }) => {
  const history = useHistory();

  const onCardPress = () => {
    history.push(`/r/${id}?view=${viewType}`);
  };

  return <WrappedRentalCard id={id} viewType={viewType} onCardPress={onCardPress} />;
};

export default DiscoverRentalCard;
